import EmbededVideo from "./EmbededVideo";

export default EmbededVideo;
